export default __webpack_public_path__ + "static/media/Tigress_MAYA_with_her_cubs_at_TADOBA.91418c8b.jpg";